import { OnInit, TemplateRef } from '@angular/core';
import { HeaderService } from '../services/header.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MessagePopupService } from '../services/message-popup.service';
import { ThemeSettingService } from '../services/theme-setting.service';
var OnetimeactionComponent = /** @class */ (function () {
    function OnetimeactionComponent(router, route, headerService, messagePopupService, themeSettingService) {
        this.router = router;
        this.route = route;
        this.headerService = headerService;
        this.messagePopupService = messagePopupService;
        this.themeSettingService = themeSettingService;
        this.isBusy = true;
    }
    OnetimeactionComponent.prototype.ngOnInit = function () {
        var _this = this;
        var themes = this.themeSettingService.getTheme();
        this.loaderConfig = themes;
        var oneTimeKey = this.route.snapshot.paramMap.get('oneTimeKey');
        var userId = this.route.snapshot.paramMap.get('userId');
        this.headerService.performOneTimeAction(userId, oneTimeKey).subscribe(function (result) {
            _this.router.navigate(["/"]);
            _this.isBusy = false;
            if (result) {
                _this.handleWorkflowReturn(result);
            }
            else {
                _this.messagePopupService.popMessage("Error", "One time key is not valid.", ["OK"]).subscribe(function (respond) {
                });
            }
        });
    };
    OnetimeactionComponent.prototype.handleWorkflowReturn = function (result) {
        var _this = this;
        var command = JSON.parse(result);
        switch (command.ReturnType) {
            case 0:
                if (command.Arguments) {
                    var path = [];
                    command.Arguments.forEach(function (element) {
                        path.push(element);
                    });
                    this.router.navigate(path);
                }
                break;
            case 1:
                this.messagePopupService.popMessage(command.Arguments[0], command.Arguments[1], ["OK"]).subscribe(function (respond) {
                });
                break;
            case 8:
                this.messagePopupService.popMessage(command.Arguments[0], command.Arguments[1], ["OK"]).subscribe(function (respond) {
                    if (respond.answer == "OK") {
                        var path = [];
                        command.Arguments.forEach(function (argument) {
                            path.push(argument);
                        });
                        if (path.length > 2) {
                            var newPath = path.slice(2);
                            _this.router.navigate(newPath);
                        }
                    }
                });
                break;
        }
    };
    return OnetimeactionComponent;
}());
export { OnetimeactionComponent };
